module.exports = "<div class=\"card-block\">\n  <app-action [action]=\"prestige\"></app-action>\n</div>\n"